<template>
  <v-dialog
    v-model="show"
    width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        <template v-if="limit.personal">Personal</template><template v-else>Global</template> Limits
      </v-card-title>

      <v-card-text>
        <v-text-field
          label="Min"
          v-model="limit.min"
          :readonly="readonly"
          hide-details
        />
        <v-text-field
          label="Max"
          v-model="limit.max"
          :readonly="readonly"
          hide-details
        />
        <v-text-field
          label="Max Per Day"
          v-model="limit.max_per_day"
          :readonly="readonly"
          hide-details
        />
        <v-text-field
          label="Max Per Week"
          v-model="limit.max_per_week"
          :readonly="readonly"
          hide-details
        />
        <v-text-field
          label="Max Per Month"
          v-model="limit.max_per_month"
          :readonly="readonly"
          hide-details
        />
        <slot name="action" v-bind:item.sync="limit"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>

</style>


<script>

  export default {
    props: {
      value: Boolean,
      limit: { default: {} },
      readonly: Boolean,
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },

    data: () => ({}),

  }
</script>
